<template>
  <pack>
    <zt-title class="mb24">
      提现管理
      <div v-show="firstLoaded" slot="after">
        <!-- <span class="remind" v-if="autoTransferStatus.isAlipaySign">*支付宝接口升级，请重新配置。</span> -->
        <zt-button
          :type="autoTransferStatus.all ? 'primary' : 'orange'"
          @click="handleOpenAutoTransferSetting"
        >自动转账配置</zt-button>
        <zt-button
          class="ml12"
          type="primary"
          @click="onOpenSetting"
        >提现设置</zt-button>
      </div>
    </zt-title>

    <!-- 查询表单 -->
    <el-form class="finder" @submit.native.prevent size="medium">
      <el-date-picker
        type="daterange"
        v-model="date"
        v-bind="datePickerBind"
        @change="onDatePickerChange"
        class="mr16 mb8"
      />

      <el-form-item label="申请人手机号：" class="mr16 mb8">
        <zt-input
          max-width="300px"
          placeholder="请输入手机号"
          v-model.trim="form.telephone"
        />
      </el-form-item>

      <el-form-item label="身份：" class="mr16 mb8">
        <el-select v-model="form.is_agent" placeholder="请选择角色" clearable>
          <el-option label="普通用户" :value="0"></el-option>
          <el-option label="代理用户" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放类型" class="mr16 mb8">
        <el-select v-model="form.type" placeholder="请选择状态" clearable>
          <el-option label="自行发放" :value="1"></el-option>
          <el-option label="支付宝打款" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" class="mr16 mb8">
        <el-select v-model="form.status" placeholder="请选择状态" clearable>
          <el-option label="申请中" :value="0"></el-option>
          <el-option label="成功" :value="1"></el-option>
          <el-option label="失败" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <zt-button
        type="primary"
        class="mr16 mb8"
        :loading="formLoading"
        @click.enter.exact="onSubmit"
        native-type="submit"
        width="80px"
        >搜索</zt-button
      >
      <zt-button
        class="mr16 mb8"
        :loading="formLoading"
        @click="onReset"
        width="80px"
        >清空</zt-button
      >
    </el-form>

    <el-alert v-if="autoTransferStatus.all" class="alert-pay" type="success" effect="dark" :closable="false">
      <span>选择支付宝转账，请点击右侧【支付宝打款审核】按钮确认打款哦~</span>
      <zt-button type="success" @click="handleGetPayQrcore">支付宝打款审核</zt-button>
      <zt-button type="success" @click="handleLookPayResult">查看支付结果</zt-button>
    </el-alert>

    <!-- 表 -->
    <el-table :data="list" size="medium" class="mt12">
      <el-table-column label="ID" prop="id" min-width="50px" />
      <el-table-column label="申请时间">
        <span slot-scope="{ row }">
          {{ row.addtime_ymd }} <br /> {{ row.addtime_hms }}
        </span>
      </el-table-column>
      <el-table-column label="申请人" prop="telephone">
        <span slot-scope="{ row }">{{ row.telephone + (row.alias_name ? `[${row.alias_name}]` : "") }}</span>
      </el-table-column>
      <el-table-column label="身份" prop="is_agent">
        <span slot-scope="{ row }">{{ row.is_agent ? "代理" : "普通用户" }}</span>
      </el-table-column>
        <el-table-column label="发放类型" prop="type">
        <span slot-scope="{ row }">{{ getTypeCN(row) }}</span>
      </el-table-column>
      <el-table-column label="订单状态" prop="status">
        <span slot-scope="{ row }">{{ status2cn(row) || '-' }}</span>
      </el-table-column>
      <el-table-column label="打款审核" prop="audit_status">
        <span slot-scope="{ row }">{{ getAuditStatusCN(row) || '-' }}</span>
      </el-table-column>
      <el-table-column label="支付宝账号" prop="paydata">
        <span slot-scope="{ row }">
          {{ payinfoFormat(row).account }} <br /> {{ payinfoFormat(row).name }}
        </span>
      </el-table-column>
      <el-table-column label="申请金额" prop="money" />
      <el-table-column label="账户当前余额" prop="commission" />
      <el-table-column label="用户注册时间">
        <span slot-scope="{ row }">
          <template v-if="row.regtime">
            {{ row.regtime.split(" ")[0] }} <br /> {{ row.regtime.split(" ")[1] }}
          </template>
        </span>
      </el-table-column>
      <el-table-column label="操作" min-width="100px" fixed="right">
        <template slot-scope="{ row }">
          <template v-if="row.status == 0">
            <zt-button
              type="primary"
              width="80px"
              size="mini"
              @click="handlePay(row)"
            >发放</zt-button>
            <zt-button
              size="mini"
              @click="onRejectPay(row)"
              width="80px"
            >拒绝</zt-button>
          </template>
          <template v-else>
            <zt-button
              size="mini"
              @click="handleResultInfo(row)"
              width="80px"
            >处理结果</zt-button>
          </template>
          <zt-button
            size="mini"
            @click="onSeeBill(row)"
            width="80px"
          >查看流水</zt-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination mt24">
      <el-pagination
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordcount"
        :page-size="form.pagesize"
      />
    </div>

    <!-- 提现设置弹窗 -->
    <SettingDg :visible.sync="settingVisible" />

    <!-- 余额明细弹窗 -->
    <TurnoverDg :visible.sync="turnoverVisible" :turnoverId="turnoverId" />

    <!-- 支付宝打款审核弹窗 -->
    <ExaMine :visible.sync="examineVisible" />

    <!-- 支付自动转账配置弹窗 -->
    <AutoTransferDg
      :visible.sync="autoTransferVisible"
      :autoTransferStatus="autoTransferStatus"
      @refresh-status="getAutoTransferStatus"
      @close="onCloseAutoTransferDg"
    />

    <!-- 用户提现弹窗 -->
    <WithdrawDg
      :visible.sync="withdrawVisible"
      :withdrawParam="withdrawParam"
      :autoTransferStatus="autoTransferStatus"
      @refresh-list="getList"
    />

    <!-- 处理结果弹窗 -->
    <ResultInfoDg
      :visible.sync="resultInfoVisible"
      :resultInfoParam="resultInfoParam"
    />

  </pack>
</template>

<script>
import SettingDg from './components/SettingDg.vue'
import TurnoverDg from './components/TurnoverDg.vue'
import AutoTransferDg from './components/AutoTransferDg.vue'
import WithdrawDg from './components/WithdrawDg.vue'
import ResultInfoDg from './components/ResultInfoDg.vue'
import ExaMine from './components/ExaMine.vue'
import { mapGetters } from 'vuex'
import { dateYMD } from '@/filters/date'
import datePickerMixins from '../mixins/datePicker'
import { message_mark_read } from '@/api/messageMark'
import taoke_check_ali_sign_up from '@/api/taoke_check_ali_sign_up'
import taoke_follow_wx_check from '@/api/taoke_follow_wx_check'
import taoke_follow_wx_qrcode from '@/api/taoke_follow_wx_qrcode'
import { signStatusMap } from './withdraw.const'
import { payinfoFormat, status2cn, auditStatus2cn } from './withdraw.utils'
import {
  taoke_commission_withdraw_apply_list,
  taoke_commission_withdraw_apply_confirm
} from '@/api/finance'
import alipayAuth from './components/alipayAuth'

export default {
  name: 'FinanceWithdraw',
  mixins: [datePickerMixins],
  components: {
    SettingDg,
    TurnoverDg,
    AutoTransferDg,
    WithdrawDg,
    ResultInfoDg,
    ExaMine,
  },
  data: () => ({
    turnoverId: '',
    turnoverVisible: false,
    examineVisible: false,
    list: [],
    formLoading: false,
    form: {
      telephone: '',
      pay_type: '', // 暂时没用上
      is_agent: '', // 暂时没用上
      add_time_begin: '',
      add_time_end: '',
      status: '', // 支付状态
      page: 1,
      pagesize: 10,
      type: '', //发放类型
    },
    recordcount: 0, // 总条数
    settingVisible: false, // 提现设置
    autoTransferVisible: false, // 自动转账可见
    // 自动转账状态
    autoTransferStatus: {
      signStatus: signStatusMap['未签约'], // 签约状态
      isAlipayAuth: false, // 支付宝授权
      isAlipaySign: false, // 支付宝签约
      all: false, // 全部条件满足
    },

    withdrawVisible: false, // 提现dialog可见
    withdrawParam: {
      // 提现参数
      info: {},
    },

    resultInfoVisible: false,
    resultInfoParam: {
      info: {},
    },
    tableLoading: false,

    firstLoaded: false,

    payinfoFormat,
    status2cn,
    auditStatus2cn,
  }),
  computed: {
    ...mapGetters(['user_info']),

    date: {
      get() {
        const { add_time_begin, add_time_end } = this.form
        if (add_time_begin && add_time_end) {
          return [ add_time_begin, add_time_end ]
        } else {
          return []
        }
      },
      set(val) {
        if (!val || val.length === 0) {
          this.form.add_time_begin = ''
          this.form.add_time_end = ''
        } else {
          this.form.add_time_begin = dateYMD(val[0]) + ' 00:00:00'
          this.form.add_time_end = dateYMD(val[1]) + ' 23:59:59'
        }

      },
    },
  },
  watch: {
    'form.telephone'(val) {
      if (val.indexOf(' ') !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, '')
      }
    },
  },
  methods: {

    // 发放状态文案
    getTypeCN(row) {
      const { type, status } = row

      // 申请中、失败 返回 -
      if ([0, 2].includes(status)) {
        return '-'
      }

      return {
        1: '自行发放',
        2: '支付宝打款',
      }[type] ?? '-'
    },

    // 审核状态中文
    getAuditStatusCN(row) {
      const { status, audit_status, type } = row

      // 订单状态是失败，发放类型是自定发放
      if (status === 2 || type === 1) {
        return '-'
      }
      return {
        0: '待审核',
        1: '已提交',
        2: '已拒绝',
      }[audit_status] ?? '-'
    },

    // 打开提现设置弹框
    onOpenSetting() {
      this.settingVisible = true
    },

    // 日期改变
    onDatePickerChange() {
      this.onSubmit()
    },

    // 搜索
    async onSubmit() {
      this.formLoading = true
      this.form.page = 1
      await this.getList()
      this.formLoading = false
    },

    // 清空筛选
    onReset() {
      this.form.telephone = ''
      this.form.pay_type = '' // 暂时没用上
      this.form.is_agent = '' // 暂时没用上
      this.form.add_time_begin = ''
      this.form.add_time_end = ''
      this.form.status = ''
      this.getList()
    },

    // 查看账单
    onSeeBill(row) {
      this.turnoverId = row.uid
      this.turnoverVisible = true
    },

    // 拒绝支付
    onRejectPay(row) {
      // 拒绝原因弹框
      this.$prompt('请输入拒绝原因', '拒绝原因', {
        beforeClose: async(action, instance, done) => {
          if (action != 'confirm') return done()

          const reject_reason = instance.inputValue
          const { data } = await taoke_commission_withdraw_apply_confirm({
            id: row.id,
            agree: 2,
            reject_reason,
          })
          this.$requestResultMessage(data, '拒绝成功')
          this.getList()
          done()
        },
      }).catch(() => {})
    },

    // 分页器
    onPageSizeChange(pagesize) {
      this.form.pagesize = pagesize

      // 当前页数*当前页面大小 > 数据总数 的时候不发请求(由onPageChange发请求)
      if (this.form.page * pagesize > this.recordcount && this.form.page != 1)
        return

      this.getList()
    },
    onPageChange(page) {
      this.form.page = page
      this.getList(true)
    },

    // 获取列表
    async getList(toTop) {
      this.tableLoading = true
      const { data } = await taoke_commission_withdraw_apply_list(this.form)

      if (data.error_code != 0) {
        this.$message.error(data.error_message)
      } else {
        this.list = data.list
        this.list.map(function(list) {
          //拆分日期
          if (list.addtime != '' && list.addtime != undefined) {
            list.addtime_ymd = list.addtime.split(' ')[0]
            list.addtime_hms = list.addtime.split(' ')[1]
          }
        })
        this.recordcount = data.recordcount
        if (toTop) {
          window.scrollTo(0, 0)
        }
      }
      this.tableLoading = false

      return data
    },

    // 打开自动转账配置
    handleOpenAutoTransferSetting() {
      this.autoTransferVisible = true
    },

    // 支付
    handlePay(row) {
      Object.assign(
        this.$data.withdrawParam,
        this.$options.data().withdrawParam
      )
      this.withdrawVisible = true
      this.withdrawParam.info = row
    },

    // 获取自动转账状态
    async getAutoTransferStatus() {
      await this.$store.dispatch('GetUserInfo')
      const { data } = await taoke_check_ali_sign_up()
      if (data.error_code !== 0 && data.error_code !== 12) {
        this.$message.error(data.error_message)
        return
      }
      const signStatus = data.audit_status
      const isAlipayAuth = this.user_info.alipay_ouath_status === 1
      const isAlipaySign = signStatus === signStatusMap['已签约']
      const all = [isAlipayAuth, isAlipaySign].every((i) => i)
      Object.assign(this.autoTransferStatus, {
        isAlipayAuth,
        isAlipaySign,
        signStatus,
        all,
      })
    },
    // 检测授权结果
    async checkAuthResult() {
      const {
        gzgzhSuccess,
        alipay_auth_result_code,
        alipay_auth_result_msg,
      } = this.$route.query
      // 关注公众号成功
      if (gzgzhSuccess) {
        await this.getAutoTransferStatus()
        await this.$alert('绑定微信成功')
        this.autoTransferVisible = true
      }

      if (alipay_auth_result_code === undefined) return


      // 延迟
      const sleep = (delayMs) => {
        return new Promise((resolve) => setTimeout(resolve, delayMs))
      }

      /**
       * 授权成功
       * @param qrcode 关注公众号二维码
       */
      const handleSuccess = async(qrcode) => {
        /**
         * 轮询扫码结果
         * @param {object} option
         * @param {function} option.success 扫码成功回调
         * @param {function} option.error 扫码失败回调
         * @param {function} option.overtimeCallback 超时回调
         * @param {number} option.intervalTime 轮询间隔时间,单位:ms,默认3秒
         * @param {number} option.overtime 超时时间,单位:ms,默认5分钟
         */
        const loopScanCode = ({
          success,
          error,
          overtimeCallback,
          intervalTime = 3000,
          overtime = 60 * 50 * 1000,
        }) => {
          let startTime = Date.now()
          let isLoop = true
          // 终止轮询
          const stop = () => (isLoop = false)

          // 轮询
          async function loop() {
            let nowTime = Date.now()

            // 终止
            if (isLoop === false) {
              return
            }

            // 授权码已过期
            if (overtime && nowTime - startTime >= overtime) {
              overtimeCallback && overtimeCallback()
              return
            }

            // 调用接口
            const result = await taoke_follow_wx_check(alipay_auth_result_code)
            switch (result.data.error_code) {
            // 成功
            case 0:
              success && success()
              break
              // 未扫码
            case 12:
              await sleep(intervalTime)
              loop()
              break
              // 错误
            default:
              error && error(result.data.error_message)
              break
            }
          }
          loop()

          return { stop }
        }

        let loopScanCodeIns = loopScanCode({
          success: () => {
            this.$router.replace({ query: {gzgzhSuccess: true} })
            this.$msgbox.close()
          },
          error: async(error_message) => {
            this.$msgbox.close()
            await this.$alert(error_message)
            alipayAuth()
          },
          overtimeCallback: async() => {
            this.$msgbox.close()
            await this.$alert('超过5分钟支付宝授权已过期，请重新授权')
            alipayAuth()
          },
        })

        this.$msgbox({
          title: '微信授权绑定',
          cancelButtonText: '取消',
          showCancelButton: true,
          showConfirmButton: false,
          closeOnClickModal: false,
          message: (() => (
            <div>
              <div>
                请使用个人微信号扫码授权绑定主推公众号，用于支付宝自动转账确认付款。
              </div>
              <div class="text-center">
                <img width="380" height="380" src={qrcode} />
              </div>
            </div>
          ))(),
          callback: (action) => {
            if (action !== 'confirm') {
              loopScanCodeIns.stop()
            }
          },
        })
      }

      /**
       * 授权失败
       */
      const handleError = async() => {
        await this.$alert(alipay_auth_result_msg || '支付宝授权失败', {
          type: 'error',
        })
        this.$router.replace({ query: {} })
      }

      // 检测授权
      if (alipay_auth_result_code) {
        // 获取关注公众号二维码，用于绑定微信
        const { data } = await taoke_follow_wx_qrcode()
        if (data.error_code === 0) {
          handleSuccess(data.img)
        } else {
          handleError()
        }
      }
      // 支付宝授权失败
      else {
        handleError()
      }
    },

    // 查看处理结果
    handleResultInfo(row) {
      this.resultInfoVisible = true
      this.resultInfoParam.info = row
    },

    // 打开支付宝打款审核
    async handleGetPayQrcore() {
      // this.$msgbox({
      //   title: '请使用微信扫描二维码并确认支付',
      //   showConfirmButton: false,
      //   center: true,
      //   message: (() => (
      //     <div class="text-center">
      //       <img
      //         width="350"
      //         height="350"
      //         src={withdraw_qrcode_confirm}
      //       />
      //     </div>
      //   ))(),
      // })
      this.examineVisible=true
    },

    // 查看支付结果
    async handleLookPayResult() {
      // this.$msgbox({
      //   title: '请使用微信扫描二维码并查看支付结果',
      //   showConfirmButton: false,
      //   center: true,
      //   message: (() => (
      //     <div class="text-center">
      //       <img
      //         width="350"
      //         height="350"
      //         src={withdraw_qrcode_result}
      //       />
      //     </div>
      //   ))(),
      // })
      this.$router.push('results')
    },

    // 关闭自动转账配置弹窗口
    onCloseAutoTransferDg() {
      if(this.$route.query.gzgzhSuccess) {
        this.$router.replace({query: {}})
      }
    },
  },

  async created() {
    await this.getAutoTransferStatus()
    this.checkAuthResult()
    await this.getList()
    this.$store.commit('UPDATA_CASHMSG', false)
    message_mark_read({ type: 'tbk_member_commission_withdraw_apply' })

    this.firstLoaded = true
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";

.finder {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    display: flex;
  }
}

.el-date-editor {
  width: 340px;
}

.alert-pay {
  /deep/ .el-alert__content {
    .el-alert__description {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
    }
    width: 100%;
    display: block;
    span {
      flex: 1;
    }
    .zt-button + .zt-button {
      margin-left: 16px;
    }
  }
}
.remind {
  color:#fe7a42;
  font-size:14px;
  font-weight:normal;
}
</style>
